import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/** Keeps a value a page was sent back with in its address, and takes the address's search away: a reload or a shared
 * link does not tell it again. */
export function useSearchOnce<Value>(value: Value | undefined): Value | undefined {
  const navigate = useNavigate();
  const [kept] = useState(value);
  useEffect(() => {
    if (value !== undefined) {
      void navigate({ to: ".", search: {}, replace: true });
    }
  }, [value, navigate]);
  return kept;
}
